import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Button,
  makeStyles,
  Container,
  Divider,
  CardContent,   
  CardHeader,
  Grid,
  TextField,
  MenuItem,
  InputLabel,
  Switch,
  Tooltip,
  IconButton
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/utils/newLoader';
import { useAlert } from "react-alert";
import PageHeader from 'src/views/Common/PageHeader';
import moment from 'moment';
import ReactToPrint from "react-to-print";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';
import MaterialTable from "material-table";
import Chip from '@material-ui/core/Chip';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CreatePdf from './createPdf';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorApprove: {
    backgroundColor: "green",
  },
  colorReject: {
    backgroundColor: "red",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const screenCode = 'EMPLOYEELEAVEFORMNEW';

export default function LeaveFormAddEdit(props) {
  const componentRef = useRef([]);
  const [isLoadingAllocatedDays, setIsLoadingAllocatedDays] = useState(false);
  const [isLoadingEditData, setIsLoadingEditData] = useState(false);
  const [title, setTitle] = useState("Employee Leave Form");
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [leaveTypes, setLeaveTypes] = useState();
  const [leaveTypesOne, setLeaveTypesOne] = useState([]);
  const [registrationNumbers, setRegistrationNumbers] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [remainingLeave, setRemainingLeave] = useState(0);
  const [refNo, setRefNo] = useState(0);
  const [allocatedDays, setAllocatedDays] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [pdfData, setpdfData] = useState({
    daysEnjoyed: 0,
    fromDate: '',
    toDate: ''
  });
  const [open, setOpen] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const [leaveRequestData, setLeaveRequestData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [leaveFormData, setLeaveFormData] = useState({
    groupID: 0,
    factoryID: 0,
    leaveTypeID: 0,
    isPayment: false,
    registrationNumber: '',
    employeeID: 0,
    fromDate: null,
    toDate: null,
    coveringPerson: '',
    noOfDays: 0,
    isCoveringPerson: false,
    applyForID: 1,
    reason: '',
    employeeRequestStatusID: 0,
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isLeaveRequestApproveReject: false
  });

  const { leaveRefNo } = useParams();
  let decryptedID = 0;
  const navigate = useNavigate();
  const alert = useAlert();

  const handleClick = () => {
    navigate('/app/LeaveForm/listing');
  };

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);

  const handleOpenApproveDialog = () => {
    setOpenApprove(true);
  };

  const handleCloseApproveDialog = () => {
    setOpenApprove(false);
  };

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermission(), getLeaveTypesForDropDown());
  }, []);

  useEffect(() => {
    const loadEditData = async () => {
      decryptedID = atob(leaveRefNo.toString());
      setRefNo(decryptedID);
      
      if (decryptedID != 0) {
        setIsLoadingEditData(true);
        
        await trackPromise(
          getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(decryptedID)
        );
        
        await trackPromise(
          getEmployeeLeaveFormDetailsByLeaveRefNo(decryptedID)
        );
        
        setIsLoadingEditData(false);
      }
    };
    
    loadEditData();
  }, [leaveRefNo]);

  useEffect(() => {
    if (leaveFormData.groupID != 0) {
      trackPromise(getFactoriesForDropDown());
    }
  }, [leaveFormData.groupID]);

  useEffect(() => {
    if (leaveFormData.factoryID != 0) {
      trackPromise(getRegistrationNumbersForDropDown());
    }
  }, [leaveFormData.factoryID]);

  useEffect(() => {
    if (isUpdate || isLoadingEditData) {
      return;
    }
    
    if (leaveFormData.registrationNumber !== '' && leaveFormData.registrationNumber !== null) {
      trackPromise(getEmployeeIDFromRegistrationNumber());
    } else if (leaveFormData.registrationNumber === '') {
      setLeaveFormData(prev => ({
        ...prev,
        employeeID: 0
      }));
    }
  }, [leaveFormData.registrationNumber, isUpdate, isLoadingEditData]); 

  useEffect(() => {
    if (!isUpdate) {
      if (leaveFormData.registrationNumber !== '' && leaveFormData.leaveTypeID && leaveFormData.employeeID !== 0) {
        getEmployeeRemainingLeaveValue(
          parseInt(leaveFormData.leaveTypeID),
          parseInt(leaveFormData.employeeID)
        );
        getAllocatedDays(
          parseInt(leaveFormData.leaveTypeID),
          parseInt(leaveFormData.employeeID)
        );
      }
    }
  }, [leaveFormData.leaveTypeID, leaveFormData.employeeID]);

  useEffect(() => {
    if (leaveFormData.fromDate && leaveFormData.toDate) {
      handleDateDifference();
    } else {
      setLeaveFormData(prev => ({ ...prev, noOfDays: 0 }));
    }
  }, [leaveFormData.fromDate, leaveFormData.toDate]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITEMPLOYEELEAVEFORM');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isLeaveRequestApproveReject = permissions.find(p => p.permissionCode === 'VIEWLEAVEREQUESTAPPROVEREJECT');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isLeaveRequestApproveReject: isLeaveRequestApproveReject !== undefined
    });

    setLeaveFormData(prev => ({
      ...prev,
      groupID: isGroupFilterEnabled !== undefined ? parseInt(tokenService.getGroupIDFromToken()) : 0,
      factoryID: isFactoryFilterEnabled !== undefined ? parseInt(tokenService.getFactoryIDFromToken()) : 0
    }));
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropDown() {
    const factory = await services.getAllFactoriesByGroupID(leaveFormData.groupID);
    setFactories(factory);

    const factoryIDs = Object.keys(factory).map(id => parseInt(id));
    const currentFactoryID = parseInt(leaveFormData.factoryID);
    
    if (currentFactoryID !== 0 && !factoryIDs.includes(currentFactoryID)) {
      setLeaveFormData(prev => ({
        ...prev,
        factoryID: 0
      }));
    }
  }

  async function getLeaveTypesForDropDown() {
    const leaveTypesDropdown = await services.getEmployeeLeaveType(); 
    const leaveTypesRaw = await services.getEmployeeLeaveTypeRaw(); 
    
    setLeaveTypes(leaveTypesDropdown);
    setLeaveTypesOne(leaveTypesRaw); 
  }

  async function getRegistrationNumbersForDropDown() {
    const response = await services.getEmployeeRegistrationNumbersByGroupFactory(
      leaveFormData.groupID,
      leaveFormData.factoryID
    );
    if (response.statusCode === "Success" && response.data) {
      setRegistrationNumbers(response.data);
    } else {
      setRegistrationNumbers([]);
    }
  }

  async function getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(LeaveRefNo) {
    let response = await services.getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(LeaveRefNo);
    setTitle("Edit Employee Leave Form");
    setIsUpdate(true);

    let model = {
      groupID: response.groupID,
      factoryID: response.factoryID,
      costCenterID: response.costCenterID,
      leaveTypeID: response.leaveTypeID,
      isPayment: response.isPayment,
      registrationNumber: response.registrationNumber,  
      employeeID: response.employeeID,
      applyForID: response.applyForID,
      fromDate: moment(response.fromDate).format('YYYY-MM-DD'),
      toDate: moment(response.toDate).format('YYYY-MM-DD'),
      noOfDays: response.noOfDays,
      reason: response.reason,
      isCoveringPerson: response.isCoveringPerson,
      coveringPerson: response.coveringPerson,
      employeeRequestStatusID: response.employeeLeaveRequestStatusID,
    };
    
    setLeaveFormData(model);
    setReportData([response]);
    setRemainingLeave(response.remainingQuntity);
    
    await getEmployeeRemainingLeaveValue(parseInt(model.leaveTypeID), parseInt(model.employeeID));
    await getAllocatedDays(parseInt(model.leaveTypeID), parseInt(model.employeeID));
  }

  async function getEmployeeIDFromRegistrationNumber() {
    if (!leaveFormData.registrationNumber || leaveFormData.registrationNumber === '') {
      return;
    }
    
    if (!leaveFormData.groupID || leaveFormData.groupID == 0) {
      return;
    }
    
    if (!leaveFormData.factoryID || leaveFormData.factoryID == 0) {
      return;
    }
    
    const response = await services.getEmployeeDetailsByRegistrationNumber(
      leaveFormData.groupID,
      leaveFormData.factoryID,
      leaveFormData.registrationNumber
    );
    
    if (response.statusCode === "Success" && response.data) {
      setLeaveFormData(prev => ({
        ...prev,
        employeeID: response.data.employeeID
      }));
    } else {
      alert.error(response.message || "Could not find employee details");
      
      setLeaveFormData(prev => ({
        ...prev,
        employeeID: 0
      }));
    }
  }

  async function getEmployeeLeaveFormDetailsByLeaveRefNo(LeaveRefNo) {
    let response = await services.getEmployeeLeaveFormDetailsByLeaveRefNo(LeaveRefNo);
    response.data.forEach((x, i) => {
      x.index = i;
    });
    setLeaveRequestData(response.data);
  }

  async function getEmployeeRemainingLeaveValue(leaveTypeID, employeeID) {
    let remaining = await services.getEmployeeRemainingLeaveValue(leaveTypeID, employeeID);
    if (remaining.statusCode == "Success") {
      setRemainingLeave(remaining.data.remainingLeaveValue);
    }
  }

  async function getAllocatedDays(leaveTypeID, employeeID) {
    setIsLoadingAllocatedDays(true);
    
    const result = await services.getAllocatedDays(
      parseInt(leaveTypeID),
      parseInt(employeeID)
    );

    if (result?.data === null || result?.data === undefined) {
      setAllocatedDays(0);
    } else {
      setAllocatedDays(result.data.allocatedDays);
    }
    
    setIsLoadingAllocatedDays(false);
  }

  async function submitApplication() {
    if (leaveFormData.employeeID === 0) {
      alert.error("Please select a valid registration number");
      return;
    }

    let pass = false;
    const from = new Date(leaveFormData.fromDate);
    const to = new Date(leaveFormData.toDate);
    const noOfDays = Math.round((to - from) / (1000 * 60 * 60 * 24)) + 1;

    if (allocatedDays === null || allocatedDays === undefined) {
      alert.error("Leave allocation data not loaded. Please try again.");
      return;
    }

    if (allocatedDays == 0) {
      setLeaveFormData({ ...leaveFormData, leaveTypeID: 0 });
      alert.error("This Employee has no leaves allocated");
      return;
    }

    const found = leaveTypesOne.find(x => x.employeeLeaveTypeID == leaveFormData.leaveTypeID);
    
    if (found && found.isPayment == true) {
      if (remainingLeave < noOfDays) {
        alert.error("Exceeds remaining number of leaves");
        return;
      } else {
        pass = true;
      }
    } else {
      if (noOfDays > allocatedDays) {
        alert.error(`You can only request up to ${allocatedDays} days for this leave type`);
        return;
      }
      pass = true;
    }

    if (pass == true) {
      const leaveRefNo = generateLeaveRefNo();

      let model = {
        groupID: parseInt(leaveFormData.groupID),
        factoryID: parseInt(leaveFormData.factoryID),
        registrationNumber: leaveFormData.registrationNumber.toString(),
        employeeID: parseInt(leaveFormData.employeeID),
        leaveTypeID: parseInt(leaveFormData.leaveTypeID),
        applyForID: parseInt(leaveFormData.applyForID),
        fromDate: leaveFormData.fromDate,
        toDate: leaveFormData.toDate,
        noOfDays: parseInt(noOfDays),
        reason: leaveFormData.reason,
        isCoveringPerson: leaveFormData.isCoveringPerson,
        coveringPerson: leaveFormData.isCoveringPerson ? leaveFormData.coveringPerson : "",
        timeFrom: leaveFormData.timeFrom || "",
        timeTo: leaveFormData.timeTo || "",
        halfID: leaveFormData.halfID || 0,
        date: leaveFormData.date || null,
        isPlucking: false,
        leaveRefNo: leaveRefNo,
        createdBy: parseInt(tokenService.getUserIDFromToken())
      };

      if (found && found.isPayment == true) {
        const leaveDays = await services.GetNonApprovalLeavesCount(model);
        
        const remainingAllocated = allocatedDays - leaveDays;
        
        if (remainingAllocated < noOfDays) {
          alert.error(`Leave count exceeds the allocated leaves. You have ${remainingAllocated} days remaining after pending requests.`);
          return;
        }
      }
      
      const response = await services.SaveLeaveFormDetails(model);
      
      if (response.statusCode == "Success") {
        alert.success(response.message);
        clearData();
        navigate('/app/LeaveForm/listing');
      } else {
        alert.error(response.message);
      }
    }
  }

  function generateLeaveRefNo() {
    const currentDate = new Date();
    const no = Math.floor(1000000 + Math.random() * 9000000);
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');
    const leaveRefNoInt = `${no}${seconds}`;
    return parseInt(leaveRefNoInt);
  }

  async function updateEmployeeLeaveDetails() {
    let model = {
      groupID: parseInt(leaveFormData.groupID),
      factoryID: parseInt(leaveFormData.factoryID),
      registrationNumber: leaveFormData.registrationNumber,
      employeeID: parseInt(leaveFormData.employeeID),
      leaveTypeID: parseInt(leaveFormData.leaveTypeID),
      applyForID: parseInt(leaveFormData.applyForID),
      fromDate: leaveFormData.fromDate,
      toDate: leaveFormData.toDate,
      noOfDays: parseInt(leaveFormData.noOfDays),
      reason: leaveFormData.reason,
      isCoveringPerson: leaveFormData.isCoveringPerson,
      coveringPerson: leaveFormData.isCoveringPerson ? leaveFormData.coveringPerson : "",
      CreatedBy: parseInt(tokenService.getUserIDFromToken()),
    };

    if (leaveFormData.isPayment == true) {
      if (remainingLeave < leaveFormData.noOfDays) {
        alert.error("Exceeds remaining number of leaves");
        return;
      }
    }

    const response = await services.updateLeaveFormDetails(model);
    if (response.statusCode == "Success") {
      alert.success(response.message);
      clearData();
      navigate('/app/LeaveForm/listing');
    } else {
      alert.error(response.message);
    }
  }

  const handleReject = async () => {
    const selectedRowsData = selectedRows.map(row => ({
      EmployeeLeaveRequestID: row.employeeLeaveRequestID,
      RegistrationNumber: row.registrationNumber,
      ModifiedBy: parseInt(tokenService.getUserIDFromToken())
    }));

    const model = { approve: selectedRowsData };
    
    const response = await services.SaveRejectedIndividualLeaveRequest(model);
    
    if (response.statusCode === "Success") {
      const updatedData = leaveRequestData.map(row => {
        if (selectedRowsData.some(sel => sel.EmployeeLeaveRequestID === row.employeeLeaveRequestID)) {
          return { ...row, employeeLeaveRequestStatusID: 3 };
        }
        return row;
      });
      setLeaveRequestData(updatedData);
      
      decryptedID = atob(leaveRefNo);
      if (decryptedID !== 0) {
        await trackPromise(
          getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(decryptedID)
        );
        await trackPromise(
          getEmployeeLeaveFormDetailsByLeaveRefNo(decryptedID)
        );
      }
      
      alert.success(response.message);
      setSelectedRows([]);
    } else {
      alert.error(response.message);
      setSelectedRows([]);
    }
    
    setOpen(false);
  };

  async function handleApproveClick() {
    const selectedRowsData = selectedRows.map(row => ({
      EmployeeLeaveRequestID: row.employeeLeaveRequestID,
      RegistrationNumber: row.registrationNumber,
      EmployeeID: row.employeeID,
      NoOfDays: row.noOfDays,
      LeaveTypeID: row.leaveTypeID,
      ShortForm: row.shortForm,
      IsPayment: row.isPayment,
      FromDate: row.fromDate,
      ToDate: row.toDate,
      ModifiedBy: parseInt(tokenService.getUserIDFromToken())
    }));

    const daysEnjoyed = selectedRowsData.length;
    let model = { approve: selectedRowsData };

    const response = await services.SaveApprovedIndividualLeaveRequest(model);

    if (response.statusCode == "Success") {
      selectedRowsData.sort((a, b) => new Date(a.FromDate) - new Date(b.FromDate));
      const FromDate = selectedRowsData[0].FromDate;
      const ToDate = selectedRowsData[selectedRowsData.length - 1].FromDate;
      setpdfData({
        ...pdfData,
        daysEnjoyed: daysEnjoyed,
        fromDate: FromDate.split('T')[0],
        toDate: ToDate.split('T')[0]
      });

      const updatedData = leaveRequestData.map(row => {
        if (selectedRowsData.some(sel => sel.EmployeeLeaveRequestID === row.employeeLeaveRequestID)) {
          return { ...row, employeeLeaveRequestStatusID: 2 };
        }
        return row;
      });
      setLeaveRequestData(updatedData);
      
      decryptedID = atob(leaveRefNo);
      if (decryptedID != 0) {
        await trackPromise(
          getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(decryptedID)
        );
        await trackPromise(
          getEmployeeLeaveFormDetailsByLeaveRefNo(decryptedID)
        );
      }
      
      setSelectedRows([]);
      alert.success(response.message);
    } else {
      alert.error(response.message);
      setSelectedRows([]);
    }
    
    handleCloseApproveDialog();
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function generateRegistrationNumberDropDown(data) {
    let items = [];
    if (data != null && data.length > 0) {
      for (let item of data) {
        items.push(
          <MenuItem key={item.registrationNumber} value={item.registrationNumber}>
            {item.registrationNumber}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader onClick={handleClick} />
        </Grid>
      </Grid>
    );
  }

  function handleDateDifference() {
    if (!leaveFormData.fromDate || !leaveFormData.toDate) {
      setLeaveFormData(prev => ({ ...prev, noOfDays: 0 }));
      return;
    }
    const oneDay = 24 * 60 * 60 * 1000;
    const startTimestamp = new Date(leaveFormData.fromDate).getTime();
    const endTimestamp = new Date(leaveFormData.toDate).getTime();
    if (isNaN(startTimestamp) || isNaN(endTimestamp)) {
      setLeaveFormData(prev => ({ ...prev, noOfDays: 0 }));
      return;
    }
    
    const diffInDays = Math.round(Math.abs((startTimestamp - endTimestamp) / oneDay) + 1);
    
    setLeaveFormData(prev => ({ ...prev, noOfDays: diffInDays }));
  }

  function handleChange(e) {
    const target = e.target;
    setLeaveFormData(prev => ({
      ...prev,
      [target.name]: target.value
    }));
  }

  function handleFromDateChange(value) {
    const formattedDate = value ? moment(value).format('YYYY-MM-DD') : null;
    setLeaveFormData(prev => ({
      ...prev,
      fromDate: formattedDate,
      toDate: formattedDate && prev.toDate && new Date(prev.toDate) < new Date(formattedDate) 
        ? null 
        : prev.toDate
    }));
  }

  function handleToDateChange(value) {
    const formattedDate = value ? moment(value).format('YYYY-MM-DD') : null;
    
    setLeaveFormData(prev => ({
      ...prev,
      toDate: formattedDate
    }));
  }

  function isCoveringPersonHandleChange(e) {
    const target = e.target;
    const value = target.name === 'isCoveringPerson' ? target.checked : target.value;
    setLeaveFormData(prev => ({
      ...prev,
      [target.name]: value
    }));
  }

  function clearData() {
    setLeaveFormData(prev => ({
      ...prev,
      registrationNumber: '',
      employeeID: 0,
      leaveTypeID: 0,
      fromDate: null,
      toDate: null,
      noOfDays: 0,
      isCoveringPerson: false,
      coveringPerson: '',
      reason: '',
      applyForID: 1
    }));
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Box mt={0}>
            <Card>
              <CardHeader title={cardTitle(title)} />
              <PerfectScrollbar>
                <Divider />
                <CardContent>
                  <Card style={{ padding: 30, marginTop: 20, marginBottom: 20 }}>
                    <Grid container spacing={3}>
                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="groupID">
                          Group *
                        </InputLabel>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          name="groupID"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.groupID}
                          variant="outlined"
                          id="groupID"
                          InputProps={{
                            readOnly: isUpdate || !permissionList.isGroupFilterEnabled
                          }}
                        >
                          <MenuItem value="0">--Select Group--</MenuItem>
                          {generateDropDownMenu(groups)}
                        </TextField>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="factoryID">
                          Factory *
                        </InputLabel>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          name="factoryID"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.factoryID}
                          variant="outlined"
                          id="factoryID"
                          InputProps={{
                            readOnly: isUpdate || !permissionList.isFactoryFilterEnabled
                          }}
                        >
                          <MenuItem value="0">--Select Factory--</MenuItem>
                          {generateDropDownMenu(factories)}
                        </TextField>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="registrationNumber">
                          Registration Number *
                        </InputLabel>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          name="registrationNumber"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.registrationNumber}
                          variant="outlined"
                          id="registrationNumber"
                          InputProps={{
                            readOnly: isUpdate
                          }}
                        >
                          <MenuItem value="">--Select Registration Number--</MenuItem>
                          {generateRegistrationNumberDropDown(registrationNumbers)}
                        </TextField>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="leaveTypeID">
                          Leave Type *
                        </InputLabel>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          name="leaveTypeID"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.leaveTypeID}
                          disabled={
                            leaveFormData.employeeRequestStatusID == 2 ||
                            leaveFormData.employeeRequestStatusID == 3
                          }
                          variant="outlined"
                          id="leaveTypeID"
                          InputProps={{ readOnly: isUpdate }}
                        >
                          <MenuItem value="0">--Select Leave Type--</MenuItem>
                          {generateDropDownMenu(leaveTypes)}
                        </TextField>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="applyForID">
                          Apply For *
                        </InputLabel>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          name="applyForID"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.applyForID}
                          disabled={
                            leaveFormData.employeeRequestStatusID == 2 ||
                            leaveFormData.employeeRequestStatusID == 3
                          }
                          variant="outlined"
                          id="applyForID"
                          InputProps={{ readOnly: true }}
                        >
                          <MenuItem value="0">--Select Apply For--</MenuItem>
                          <MenuItem value="1">Full Day</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>

                    <br />
                    <Divider />
                    <br />

                    <Grid container spacing={3}>
                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="fromDate">
                          From Date *
                        </InputLabel>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disableCloseOnSelect
                            autoOk
                            format="yyyy-MM-dd"
                            fullWidth
                            size="small"
                            name="fromDate"
                            minDate={new Date()} 
                            maxDate={leaveFormData.toDate || undefined}
                            onChange={(e) => handleFromDateChange(e)}
                            value={leaveFormData.fromDate}
                            disabled={
                              leaveFormData.employeeRequestStatusID == 2 ||
                              leaveFormData.employeeRequestStatusID == 3
                            }
                            inputVariant="outlined"
                            id="fromDate"
                            inputProps={{ readOnly: isUpdate }}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="toDate">
                          To Date *
                        </InputLabel>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disableCloseOnSelect
                            autoOk
                            format="yyyy-MM-dd"
                            fullWidth
                            size="small"
                            name="toDate"
                            minDate={leaveFormData.fromDate || new Date()} 
                            onChange={(e) => handleToDateChange(e)}
                            value={leaveFormData.toDate}
                            disabled={
                              leaveFormData.employeeRequestStatusID == 2 ||
                              leaveFormData.employeeRequestStatusID == 3
                            }
                            inputVariant="outlined"
                            id="toDate"
                            inputProps={{ readOnly: isUpdate }}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="noOfDays">
                          No Of Days *
                        </InputLabel>
                        <TextField
                          fullWidth
                          size="small"
                          name="noOfDays"
                          type="number"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.noOfDays}
                          disabled
                          variant="outlined"
                          id="noOfDays"
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item md={8} xs={12}>
                        <InputLabel shrink id="reason">
                          Reason
                        </InputLabel>
                        <TextField
                          fullWidth
                          size="small"
                          name="reason"
                          onChange={(e) => handleChange(e)}
                          value={leaveFormData.reason}
                          disabled={
                            leaveFormData.employeeRequestStatusID == 2 ||
                            leaveFormData.employeeRequestStatusID == 3
                          }
                          variant="outlined"
                          id="reason"
                          InputProps={{ readOnly: isUpdate }}
                          multiline
                          rows={3}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item md={4} xs={12}>
                        <InputLabel shrink id="isCoveringPerson">
                          Is Covering Person
                        </InputLabel>
                        <Switch
                          checked={leaveFormData.isCoveringPerson}
                          size="small"
                          onChange={(e) => isCoveringPersonHandleChange(e)}
                          name="isCoveringPerson"
                          value={leaveFormData.isCoveringPerson}
                          disabled={
                            leaveFormData.employeeRequestStatusID == 2 ||
                            leaveFormData.employeeRequestStatusID == 3 ||
                            isUpdate
                          }
                        />
                      </Grid>
                    </Grid>

                    {leaveFormData.isCoveringPerson === true ? (
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="coveringPerson">
                            Covering Person
                          </InputLabel>
                          <TextField
                            fullWidth
                            size="small"
                            name="coveringPerson"
                            onChange={(e) => handleChange(e)}
                            value={leaveFormData.coveringPerson}
                            disabled={false}
                            variant="outlined"
                            id="coveringPerson"
                            InputProps={{ readOnly: isUpdate }}
                          />
                        </Grid>
                      </Grid>
                    ) : null}

                    <Grid container spacing={3}>
                      {permissionList.isLeaveRequestApproveReject && isUpdate ? (
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="remainingLeave">
                            Remaining Leave Count
                          </InputLabel>
                          <TextField
                            fullWidth
                            size="small"
                            name="remainingLeave"
                            type="number"
                            value={remainingLeave}
                            variant="outlined"
                            id="remainingLeave"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                      ) : null}
                      {permissionList.isLeaveRequestApproveReject && isUpdate ? (
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="refNo">
                            Ref No
                          </InputLabel>
                          <TextField
                            fullWidth
                            size="small"
                            name="refNo"
                            type="number"
                            value={refNo}
                            variant="outlined"
                            id="refNo"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                      ) : null}
                    </Grid>
                  </Card>
                </CardContent>

                {leaveRequestData.length > 0 ? (
                  <Box minWidth={1000}>
                    <MaterialTable
                      title="Multiple Actions Preview"
                      columns={[
                        { title: 'Reg.No', field: 'registrationNumber' },
                        { title: 'Emp.Name', field: 'employeeName' },
                        { title: 'Type', field: 'employeeLeaveTypeName' },
                        {
                          title: 'Apply For',
                          field: 'applyForID',
                          render: rowData => {
                            if (rowData.applyForID == 1) return "Full Day";
                            if (rowData.applyForID == 2) return "Half Day";
                            return '-';
                          }
                        },
                        { title: 'F.Date', field: 'fromDate', render: rowData => rowData.fromDate.split('T')[0] },
                        { title: 'T.Date', field: 'toDate', render: rowData => rowData.toDate.split('T')[0] },
                        {
                          title: 'Status',
                          field: 'employeeLeaveRequestStatusID',
                          render: rowData => {
                            let label, color;
                            switch (rowData.employeeLeaveRequestStatusID) {
                              case 1: label = 'Pending'; color = 'default'; break;
                              case 2: label = 'Approved'; color = 'success'; break;
                              default: label = 'Rejected'; color = 'error'; break;
                            }
                            return <Chip variant="outlined" label={label} color={color} />;
                          }
                        },
                        {
                          title: 'Action',
                          field: 'selected',
                          render: rowData => {
                            if (rowData.employeeLeaveRequestStatusID === 1) {
                              return (
                                <Checkbox
                                  checked={rowData.tableData.checked === true}
                                  onChange={() => {
                                    const updatedData = [...leaveRequestData];
                                    const index = updatedData.findIndex(
                                      item => item.tableData.id === rowData.tableData.id
                                    );
                                    updatedData[index].tableData.checked = !updatedData[index].tableData.checked;
                                    const selected = updatedData.filter(item => item.tableData.checked);
                                    setSelectedRows(selected);
                                    setLeaveRequestData(updatedData);
                                  }}
                                />
                              );
                            }
                            return (
                              <Checkbox checked={true} disabled />
                            );
                          }
                        },
                        {
                          title: 'PDF',
                          field: 'button',
                          render: rowData => {
                            componentRef.current[rowData.index] = componentRef.current[rowData.index];
                            return rowData.employeeLeaveRequestStatusID === 2 ? (
                              <>
                                <ReactToPrint
                                  documentTitle="Leave Entry Form"
                                  trigger={() => (
                                    <Tooltip title="PDF">
                                      <IconButton aria-label="pdf">
                                        <PictureAsPdfIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                  content={() => componentRef.current[rowData.index]}
                                />
                                <div hidden={true}>
                                  <CreatePdf
                                    ref={(el) => (componentRef.current[rowData.index] = el)}
                                    reportData={reportData}
                                    pdfData={{
                                      ...reportData[0],  
                                      ...rowData,        
                                    }}
                                    leaveRequestData={leaveRequestData}
                                  />
                                </div>
                              </>
                            ) : null;
                          }
                        }
                      ]}
                      data={leaveRequestData}
                      options={{
                        exportButton: false,
                        showTitle: false,
                        headerStyle: { textAlign: "left", height: '1%' },
                        cellStyle: { textAlign: "left" },
                        columnResizable: false,
                        actionsColumnIndex: -1
                      }}
                    />
                  </Box>
                ) : null}

                <Box display="flex" justifyContent="flex-end" p={2}>
                  {(leaveFormData.employeeRequestStatusID == 0 || leaveFormData.employeeRequestStatusID == 1) && !isUpdate ? (
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => trackPromise(submitApplication())}
                      disabled={isLoadingAllocatedDays || allocatedDays === null} 
                      style={{ marginLeft: 10 }}
                    >
                      Send To Approve
                    </Button>
                  ) : null}

                  {permissionList.isLeaveRequestApproveReject && isUpdate && selectedRows.length > 0 ? (
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ marginLeft: 10 }}
                      className={classes.colorApprove}
                      onClick={handleOpenApproveDialog}
                    >
                      Approve
                    </Button>
                  ) : null}

                  {permissionList.isLeaveRequestApproveReject && isUpdate && selectedRows.length > 0 ? (
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ marginRight: '1rem', marginLeft: 10 }}
                      className={classes.colorReject}
                      onClick={handleOpenDialog}
                    >
                      Reject
                    </Button>
                  ) : null}
                </Box>
              </PerfectScrollbar>
            </Card>
          </Box>
        </Container>
      </Page>
      <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Reject</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ fontSize: '18px' }}>
            Are you sure you want to reject this request?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => trackPromise(handleReject())} color="primary" autoFocus>
            Yes
          </Button>
          <Button onClick={handleCloseDialog} color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openApprove} onClose={handleCloseApproveDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Approve</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ fontSize: '18px' }}>
            Are you sure you want to approve {selectedRows.length} leave request(s)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => trackPromise(handleApproveClick())} 
            color="primary" 
            autoFocus
          >
            Yes
          </Button>
          <Button onClick={handleCloseApproveDialog} color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}